export const chapter4Translations = {
  name: "Sura ya 4: Kusulibiwa na Ufufuo",
  description: "Fuata hadithi ya mateso, kifo na ufufuo wa Yesu",
  spiritualWisdom: "Msalaba ni ishara ya ushindi wa mwisho wa upendo na ushindi juu ya dhambi. Ufufuo unatupatia ahadi ya maisha mapya katika Kristo.",
  
  levels: {
    40: {
      name: "Kukamatwa",
      challenge: "Jifunze kuhusu kukamatwa kwa Yesu katika bustani ya Gethsemane",
      
      questions: {
        easy: {
          question: "Yesu alikamatwa katika bustani gani?",
          options: ["Gethsemane", "Edeni", "Mizeituni", "Nazareti"],
          correctAnswer: 0,
          difficulty: "easy"
        },
        medium: {
          question: "Yuda alitumia ishara gani kumsaliti Yesu?",
          options: ["Kushikana mikono", "Busu", "Neno", "Ishara"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Mwanafunzi yupi alikata sikio la mtumishi wa kuhani mkuu kwa upanga wake?",
          options: ["Yakobo", "Yohana", "Petro", "Andrea"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Gethsemane ni bustani miguuni mwa Mlima wa Mizeituni",
        "Yuda alimsaliti Yesu kwa vipande 30 vya fedha",
        "Yesu aliponya sikio la mtumishi kwa muujiza"
      ],
      
      funFacts: [
        "Gethsemane inamaanisha 'shinikizo la mafuta', mahali ambapo mafuta ya zeituni yalifanywa",
        "Kukamatwa kwa Yesu kulitokea usiku wa manane",
        "Yesu alienda kwa amani, akiwaomba wanafunzi wake wasipingane kwa vurugu"
      ]
    },

    41: {
      name: "Ukanuzi wa Petro",
      challenge: "Jifunze jinsi Petro alivyomkana Yesu mara tatu",
      
      questions: {
        easy: {
          question: "Petro alimkana Yesu mara ngapi?",
          options: ["Mara moja", "Mara mbili", "Mara tatu", "Mara nne"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "Nini kilitokea baada ya ukanuzi wa tatu wa Petro?",
          options: ["Jua lilichomoza", "Jogoo aliwika", "Radi ilinguruma", "Tetemeko la ardhi lilitokea"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Petro alikuwa wapi alipomkana Yesu?",
          options: ["Hekaluni", "Uani wa kuhani mkuu", "Jumba la Pilato", "Gethsemane"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Yesu alitabiri ukanuzi wa Petro",
        "Petro alilia kwa uchungu baada ya kutambua alichofanya",
        "Yote yalitokea usiku huo huo"
      ],
      
      funFacts: [
        "Yesu alisema 'Kabla jogoo hajawika, utanikana mara tatu'",
        "Ukanuzi wa Petro ni mfano wenye nguvu wa udhaifu wa kibinadamu na msamaha wa kimungu",
        "Petro baadaye akawa kiongozi mkuu wa Kanisa"
      ]
    },

    42: {
      name: "Yesu Mbele ya Pilato",
      challenge: "Jifunze kuhusu kusikilizwa kwa Yesu mbele ya mtawala wa Kirumi",
      
      questions: {
        easy: {
          question: "Pilato alikuwa nani?",
          options: ["Mwanafunzi", "Mtawala wa Kirumi", "Kuhani mkuu", "Farisayo"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Pilato hakupata nini kwa Yesu?",
          options: ["Hekima", "Hatia", "Ujasiri", "Nguvu"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Pilato alifanya nini ili kuonyesha hana hatia?",
          options: ["Alinawa mikono", "Alirarua vazi lake", "Alifunga", "Aliomba"],
          correctAnswer: 0,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Pilato alitaka kumwachia Yesu",
        "Umati ulidai Yesu asulubiwe",
        "Pilato alishindwa na shinikizo la kisiasa"
      ],
      
      funFacts: [
        "Mke wa Pilato alimwonya asimfanyie Yesu chochote",
        "Kunawa mikono kulikuwa ni ishara ya kutokuwa na hatia katika mila ya Kiyahudi",
        "Uamuzi wa Pilato ulionyesha kushindwa kwa haki ya kibinadamu"
      ]
    },

    43: {
      name: "Baraba au Yesu",
      challenge: "Jifunze kuhusu uchaguzi wa umati kwa Baraba",
      
      questions: {
        easy: {
          question: "Baraba alikuwa nani?",
          options: ["Mwanafunzi", "Mnyang'anyi", "Kuhani", "Mfalme"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Pilato aliweza kufanya nini wakati wa sikukuu ya Kiyahudi?",
          options: ["Kumwachia mfungwa mmoja", "Kusamehe kodi", "Kutoa karamu", "Kufunga hekalu"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "Umati ulichagua nani?",
          options: ["Yesu", "Baraba", "Wote wawili", "Hakuna"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Ilikuwa wakati wa sikukuu ya Pasaka",
        "Umati ulidai Yesu asulubiwe",
        "Baraba alikuwa muuaji na mwasi"
      ],
      
      funFacts: [
        "Jina Baraba linamaanisha 'mwana wa baba'",
        "Kuachiwa kwa Baraba ni ishara ya dhabihu ya Kristo",
        "Sisi sote ni Baraba, tuliokombolewa kwa dhabihu ya Yesu"
      ]
    },

    44: {
      name: "Kupigwa Mijeledi na Taji la Miiba",
      challenge: "Jifunze kuhusu mateso ya Yesu",
      
      questions: {
        easy: {
          question: "Askari waliweka nini kichwani mwa Yesu?",
          options: ["Taji la dhahabu", "Taji la miiba", "Taji la maua", "Kilemba"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Askari walimdhihaki Yesu vipi?",
          options: ["Kwa kumwita mfalme", "Kwa kumpiga mawe", "Kwa kumfunga gerezani", "Kwa kumpuuza"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "Mjeledi wa Kirumi ulikuwa na nini?",
          options: ["Kamba za ngozi", "Vipande vya mifupa na chuma", "Mbao tu", "Kamba"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Kupigwa mijeledi kulikuwa adhabu ya kikatili ya Kirumi",
        "Askari walimvisha Yesu joho la zambarau",
        "Yesu alivumilia yote haya kwa ukimya"
      ],
      
      funFacts: [
        "Taji la miiba linawakilisha laana ya dhambi",
        "Rangi ya zambarau ilikuwa rangi ya kifalme, iliyotumika kwa dhihaka",
        "Mateso ya Yesu yanatimiza unabii wa Isaya"
      ]
    },

    45: {
      name: "Njia kwenda Golgotha",
      challenge: "Jifunze jinsi Yesu alivyobeba msalaba",
      
      questions: {
        easy: {
          question: "Yesu alibeba nini?",
          options: ["Bendera", "Msalaba", "Taji", "Upanga"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Nani alimsaidia Yesu kubeba msalaba?",
          options: ["Petro", "Yohana", "Simoni wa Kurene", "Yosefu"],
          correctAnswer: 2,
          difficulty: "medium"
        },
        hard: {
          question: "Golgotha inamaanisha nini?",
          options: ["Mlima mtakatifu", "Mahali pa fuvu la kichwa", "Mahali pa amani", "Mahali pa haki"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Yesu alianguka mara kadhaa kwa udhaifu",
        "Wanawake walilia njiani",
        "Msafara ulipita katikati ya mji"
      ],
      
      funFacts: [
        "Msalaba ulizani karibu kilo 40-50",
        "Golgotha ilikuwa nje ya kuta za mji",
        "Simoni wa Kurene alitoka Afrika"
      ]
    },

    46: {
      name: "Kusulubiwa",
      challenge: "Jifunze kuhusu kusulubiwa kwa Yesu",
      
      questions: {
        easy: {
          question: "Yesu alisulubiwa na watu wangapi wengine?",
          options: ["Hakuna", "Mmoja", "Wawili", "Watatu"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "Yesu alisema nini msalabani: 'Baba, ___ wao'?",
          options: ["Waokoe", "Wasamehe", "Wazuie", "Waadhibu"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Maandishi yaliyokuwa msalabani yalikuwa nini?",
          options: ["Mwenye dhambi", "Mfalme wa Wayahudi", "Mwasi", "Nabii"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Yesu alisulubiwa saa ya tatu ya mchana",
        "Askari walipiga kura kwa ajili ya mavazi yake",
        "Yesu alizungumza maneno saba kutoka msalabani"
      ],
      
      funFacts: [
        "Maandishi yaliandikwa kwa lugha tatu: Kiebrania, Kilatini na Kigiriki",
        "Mwizi mmoja alitubu wakati wa mwisho",
        "Yesu alimkabidhi mama yake kwa utunzaji wa Yohana"
      ]
    },

    47: {
      name: "Kifo cha Yesu",
      challenge: "Jifunze kuhusu masaa ya mwisho ya Yesu",
      
      questions: {
        easy: {
          question: "Nini kilitokea wakati wa kifo cha Yesu?",
          options: ["Jua lilingʼaa zaidi", "Giza likatanda", "Mvua ilinyesha", "Upinde wa mvua ulionekana"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Nini kiliraruka hekaluni?",
          options: ["Sakafu", "Pazia", "Ukuta", "Dari"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Maneno ya mwisho ya Yesu yalikuwa nini?",
          options: ["Imekwisha", "Nina kiu", "Baba, mikononi mwako naiachia roho yangu", "Kwa nini umeniacha"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Giza lilidumu masaa matatu",
        "Askari alichoma ubavuni mwa Yesu kwa mkuki",
        "Jemadari alisema 'Kweli huyu alikuwa Mwana wa Mungu'"
      ],
      
      funFacts: [
        "Pazia la hekalu liliraruka kutoka juu hadi chini, sio kwa mkono wa mwanadamu",
        "Hili lilitokea wakati wa Pasaka, wakati mwana-kondoo alipotolewa dhabihu",
        "Kifo cha Yesu kililipa gharama ya dhambi"
      ]
    },

    48: {
      name: "Mazishi",
      challenge: "Jifunze kuhusu mazishi ya Yesu",
      
      questions: {
        easy: {
          question: "Yesu aliwekwa katika kaburi la nani?",
          options: ["Petro", "Yosefu wa Arimathaya", "Nikodemo", "Lazaro"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Mwili wa Yesu ulifunikwa na nini?",
          options: ["Joho la zambarau", "Mavazi ya dhahabu", "Kitani cheupe", "Hakuna mavazi"],
          correctAnswer: 2,
          difficulty: "medium"
        },
        hard: {
          question: "Nikodemo alileta nini kwa ajili ya mwili wa Yesu?",
          options: ["Mafuta", "Manemane na udi", "Maji", "Maua"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Kaburi lilikuwa limechongwa kwenye mwamba mpya",
        "Jiwe kubwa lilivingʼirishwa kuuziba mlango",
        "Walinzi waliwekwa kulinda kaburi"
      ],
      
      funFacts: [
        "Lilikuwa kaburi la mtu tajiri, likitimiza unabii wa Isaya",
        "Mazishi yalifanywa kwa haraka kwa sababu Sabato ilikuwa inakaribia",
        "Yosefu alikuwa mwanafunzi wa siri aliyekuwa jasiri"
      ]
    },

    49: {
      name: "Kaburi Tupu",
      challenge: "Jifunze kuhusu ugunduzi wa asubuhi ya ufufuo",
      
      questions: {
        easy: {
          question: "Nani alipata kaburi tupu kwanza?",
          options: ["Petro", "Yohana", "Wanawake", "Askari"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "Jiwe lilikuwa wapi?",
          options: ["Limevunjika", "Limevingʼirishwa", "Bado lipo", "Limetoweka"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Wanawake walikutana na malaika wangapi kaburini?",
          options: ["Hakuna", "Mmoja", "Wawili", "Watatu"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Ilikuwa asubuhi ya siku ya kwanza ya juma",
        "Wanawake walikuja kumpaka mafuta mwili wa Yesu",
        "Malaika walitangaza habari njema"
      ],
      
      funFacts: [
        "Wanawake walikuwa mashahidi wa kwanza, maelezo ya mapinduzi",
        "Petro na Yohana walikimbilia kaburini",
        "Kaburi tupu peke yake hailikuwa ya kutosha, Yesu alihitaji kuonekana"
      ]
    },

    50: {
      name: "Yesu Anamtokea Maria Magdalene",
      challenge: "Jifunze kuhusu kuonekana kwa kwanza kwa Yesu",
      
      questions: {
        easy: {
          question: "Yesu alimtokea kwanza nani baada ya kufufuka?",
          options: ["Petro", "Yohana", "Maria Magdalene", "Thoma"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "Maria alimdhania Yesu kuwa nani mwanzoni?",
          options: ["Malaika", "Mbuzi-shamba", "Askari", "Farisayo"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Yesu alimwambia Maria nini alipomtambua?",
          options: ["Nenda ukawaeleze", "Usiniguse", "Usiogope", "Amini"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Maria alikuwa analia karibu na kaburi",
        "Yesu alimwita kwa jina",
        "Alimtuma kumweleza ndugu zake"
      ],
      
      funFacts: [
        "Yesu alichagua mwanamke kwa kuonekana kwake kwa mara ya kwanza",
        "Maria akawa mtume wa kwanza",
        "Alimwita 'Raboni' (Mwalimu)"
      ]
    },

    51: {
      name: "Njiani kwenda Emau",
      challenge: "Jifunze kuhusu kuonekana kwa Yesu njiani",
      
      questions: {
        easy: {
          question: "Wanafunzi wangapi walikuwa wakienda Emau?",
          options: ["Mmoja", "Wawili", "Watatu", "Wanne"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Wanafunzi walimtambua Yesu lini?",
          options: ["Mara moja", "Alipomega mkate", "Njiani", "Hawakumtambua kamwe"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Yesu aliwaeleza nini njiani?",
          options: ["Siku za usoni", "Maandiko", "Sheria", "Miujiza"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Yesu alitembea nao kama mgeni",
        "Mioyo yao ilikuwa ikiwaka alipozungumza",
        "Yesu alitoweka walipomtambua"
      ],
      
      funFacts: [
        "Emau ilikuwa umbali wa kilomita 11 kutoka Yerusalemu",
        "Yesu aliwaonyesha jinsi Maandiko yote yalivyozungumza kumhusu",
        "Wanafunzi walirudi Yerusalemu mara moja wakikimbia"
      ]
    },

    52: {
      name: "Kuonekana kwa Wanafunzi",
      challenge: "Jifunze kuhusu kuonekana kwa Yesu katika chumba kilichofungwa",
      
      questions: {
        easy: {
          question: "Wanafunzi walikuwa wapi Yesu alipoonekana?",
          options: ["Hekaluni", "Sokoni", "Katika chumba kilichofungwa", "Gethsemane"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "Yesu aliwaonyesha wanafunzi nini?",
          options: ["Vidonda vyake", "Uso wake", "Mavazi yake", "Nuru"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "Mwanafunzi yupi hakuwepo mara ya kwanza?",
          options: ["Petro", "Yohana", "Thoma", "Yakobo"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Milango ilikuwa imefungwa kwa hofu",
        "Yesu alisema 'Amani iwe nanyi'",
        "Aliwapulizia na kusema 'Pokeeni Roho Mtakatifu'"
      ],
      
      funFacts: [
        "Yesu alikula nao ili kuthibitisha hakuwa mzimu",
        "Thoma aliamini wiki moja baadaye",
        "Yesu alionekana mara nyingi kwa siku 40"
      ]
    }
  }
};
